import { useState, useEffect, useCallback } from "react";

export interface City {
  label: string;
  value: string;
}
function useLocation(defaultLocation: any, cities: any) {
  // const [permission, setPermission] = useState<PermissionStatus | null>(null);
  // const [location, setLocation] = useState<GeolocationCoordinates | null>(null);
  const [city, setCity] = useState<City | null>(null);

  // const reverseGeocoding = useCallback(
  //   async (latitude: number, longitude: number) => {
  //     try {
  //       console.log("geo", process.env.NEXT_PUBLIC_REVERSE_GEOCODING_API_URL);
  //       const response = await fetch(
  //         `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json&zoom=13`
  //       );
  //       if (!response.ok)
  //         throw new Error(`HTTP error! status: ${response.status}`);

  //       const { address } = await response.json();
  //       const extractedCity =
  //         address?.city?.toLowerCase() ||
  //         address?.town?.toLowerCase() ||
  //         address?.village?.toLowerCase() ||
  //         null;

  //       if (extractedCity) {
  //         const isPropertiesAvailable: any =
  //           cities &&
  //           cities?.length > 0 &&
  //           cities.find((opt: any) => opt.value.match(extractedCity));

  //         if (isPropertiesAvailable) {
  //           setCity(isPropertiesAvailable);
  //           // setState(extractedState);
  //         } else {
  //           setCity({
  //             label: defaultLocation?.city_name,
  //             value: defaultLocation?.city_slug,
  //           });
  //         }
  //       }
  //     } catch (error) {
  //       setCity({
  //         label: defaultLocation?.city_name,
  //         value: defaultLocation?.city_slug,
  //       });
  //       console.error("Error fetching location details:", error);
  //     }
  //   },
  //   [defaultLocation]
  // );

  // const getLocation = useCallback(() => {
  //   navigator.geolocation.getCurrentPosition(
  //     async (position) => {
  //       const { latitude, longitude } = position.coords;
  //       setLocation(position.coords);
  //       await reverseGeocoding(latitude, longitude);
  //     },
  //     (error) => {
  //       setCity({
  //         label: defaultLocation?.city_name,
  //         value: defaultLocation?.city_slug,
  //       });
  //       console.log("Error getting location:", error);
  //     }
  //   );
  // }, [reverseGeocoding]);

  useEffect(() => {
    const isCurrentLocationDetectionDisabled = true;
    if (isCurrentLocationDetectionDisabled) {
      setCity({
        label: "All Cities",
        value: "",
      });
      return;
    }
    // (async () => {
    //   if (typeof window !== "undefined" && "geolocation" in navigator) {
    //     if ("permissions" in navigator && navigator.permissions.query) {
    //       const status = await navigator?.permissions?.query({
    //         name: "geolocation",
    //       });
    //       setPermission(status);

    //       if (status.state === "denied") {
    //         setCity({
    //           label: defaultLocation?.city_name,
    //           value: defaultLocation?.city_slug,
    //         });
    //       }
    //       if (status.state === "prompt" || status.state === "granted") {
    //         if (status.state === "prompt") {
    //           setCity({
    //             label: defaultLocation?.city_name,
    //             value: defaultLocation?.city_slug,
    //           });
    //         }
    //         getLocation();
    //       }
    //     } else {
    //       console.warn("Geolocation permissions API not supported.");
    //       getLocation();
    //     }
    //   }
    // })();
    //}, [getLocation, defaultLocation]);
  }, []);

  // return { permission, location, city };
  return { city };
}

export default useLocation;
